import React from 'react';

import { images } from '../../constants';
import './AboutUs.css';

const AboutUs = () => (
  <div className="app__aboutus app__bg flex__center section__padding" id="about">
    <div className="app__aboutus-overlay flex__center">
      <img src={images.G} alt="G_overlay" />
    </div>

    <div className="app__aboutus-content flex__center">
      <div className="app__aboutus-content_about">
        <h1 className="headtext__cormorant">Unparalled Quality</h1>
        <p className="p__opensans">Sourcing the finest ingredients to create a one of a kind dining experience for our guests is a never ending labor of love.</p>
        <button type="button" className="custom__button">Learn More</button>
      </div>

      <div className="app__aboutus-content_knife flex__center">
        <img src={images.knife} alt="about_knife" />
      </div>

      <div className="app__aboutus-content_history">
        <h1 className="headtext__cormorant">Unmatched Taste</h1>
        <p className="p__opensans">Compromise is never an option, all of our chefs are world class and have multiple Michelin stars.</p>
        <button type="button" className="custom__button">Learn More</button>
      </div>
    </div>
  </div>
);

export default AboutUs;